import Vue from 'vue'
import editor from 'vue2-medium-editor'
import 'medium-editor/dist/css/medium-editor.min.css'
import 'medium-editor/dist/css/themes/default.min.css'

Vue.component('medium-editor', editor)
